/**
 * Query keys for board queries, shared by every board query and mutation hook
 * so reads and writes name the same cache entries.
 *
 * The org's board list sits under "boards" and each board's record under
 * "board", so invalidating the list leaves every board's record cached, and the
 * other way round.
 *
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const boardQueryKeys = {
  list: (orgId: string) => ["boards", orgId] as const,
  id: (boardId: string, orgId: string) => ["board", orgId, boardId] as const,
};
